export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0D5C46" />
    <path d="M32 15v34M15 32h34" stroke="#FFFFFF" strokeWidth="8" strokeLinecap="round" />
    <path d="M33 31c8-2 11-7 11-14-8 0-11 5-11 14z" fill="#10B981" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-display text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
        OneCare
      </span>
      <span className="block font-mono text-[10px] font-medium tracking-[0.28em] text-emerald-700">
        PHARMACY
      </span>
    </span>
  </span>
);
